import { useState, useEffect } from 'react';
import { getProviderOverview } from 'api/provider';
import type { ProviderOverviewVo } from 'types/providerOverview';

export default function useProviderOverview(): [ProviderOverviewVo, boolean, () => Promise<void>] {
    const [data, setData] = useState<ProviderOverviewVo>({
        providerNameSlug: '',
        photo: '',
        firstName: '',
        lastName: '',
        credential: '',
    });
    const [loading, setLoading] = useState(false);

    const fetchData = async () => {
        try {
            setLoading(true);
            const res = await getProviderOverview();
            if (!res.error) {
                setData(res.data.data || {});
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return [data, loading, fetchData];
}
